module.exports = __webpack_public_path__ + "static/contact1-eda00dce768960ff9dd50f38eadbc8f6.jpg";